<div class="toggle-section">
  <!-- one node per setting rather than parallel name/toggle columns, so a row
       cannot drift out of alignment and the list can wrap into two columns -->
  <div class="settings-grid">
    <div class="setting-item" *ngFor="let setting of generalSettings">
      <span class="setting-name">{{ setting.name }}</span>
      <div class="setting-control">
        <tg-toggle
          [switchActive]="setting.active"
          (switchActiveChange)="settingToggleChange($event, setting)"
          [disabled]="disableSetting(setting)"
        ></tg-toggle>
        <div
          [ngbPopover]="setting.tooltipText | translate"
          placement="top"
          triggers="hover"
          class="setting-tooltip"
        >
          i
        </div>
      </div>
    </div>
  </div>
</div>
